<script lang="ts">
    import {
        mapEditorEntityModeStore,
        mapEditorPlacementBlockReasonStore,
    } from "../../../Stores/MapEditorStore";
    import EntityEditorPicker from "./EntityEditorPicker.svelte";
    import EntityPropertiesEditor from "./EntityPropertiesEditor.svelte";
</script>

{#if $mapEditorPlacementBlockReasonStore}
    <div
        style="margin:0.25rem 0.5rem;padding:0.4rem 0.6rem;border-radius:0.375rem;background:rgba(220,38,38,0.15);border:1px solid rgba(220,38,38,0.5);color:#fca5a5;font-size:0.8rem;line-height:1.25;"
    >
        ⚠ {$mapEditorPlacementBlockReasonStore}
    </div>
{/if}

{#if $mapEditorEntityModeStore === "ADD"}
    <EntityEditorPicker />
{/if}
{#if $mapEditorEntityModeStore === "EDIT"}
    <EntityPropertiesEditor />
{/if}
